/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardian_Create_Is_TeenInputs */

const fr_guardian_create_is_teen = /** @type {(inputs: Guardian_Create_Is_TeenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ado (pourra rejoindre un cours adulte avec un parent)`)
};

/**

* @param {Guardian_Create_Is_TeenInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const guardian_create_is_teen = /** @type {((inputs?: Guardian_Create_Is_TeenInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardian_Create_Is_TeenInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_guardian_create_is_teen(inputs)
});